// Cloudflare Turnstile sitekey resolver.
//
// The production sitekey is scoped to the live custom domains only. When the
// site runs on a Lovable preview host (*.lovableproject.com, *.lovable.app,
// localhost, etc.) the production sitekey triggers a 110200 domain-mismatch
// error in the browser console. We swap in Cloudflare's always-pass TEST
// sitekey for those hosts so previews stay clean and the widget works.
//
// Cloudflare test sitekeys: https://developers.cloudflare.com/turnstile/troubleshooting/testing/
const TEST_SITEKEY_ALWAYS_PASS = "1x00000000000000000000AA";

const PRODUCTION_HOSTS = new Set([
  "vendingmachines.free",
  "www.vendingmachines.free",
  "vendingmachinefree.com",
  "www.vendingmachinefree.com",
]);

export function getTurnstileSiteKey(): string | undefined {
  const envKey = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;
  if (!envKey) return undefined;
  if (typeof window === "undefined") return envKey;
  const host = window.location.hostname.toLowerCase();
  if (PRODUCTION_HOSTS.has(host)) return envKey;
  return TEST_SITEKEY_ALWAYS_PASS;
}
